<template>
  <ItemDialog ref="dialogRef" imageType="alert" :initialOpen="false">
    <template v-slot:content-area>
      <h2>キャンセルに失敗しました</h2>
      <p>乗車済みの可能性があります</p>
    </template>
    <template v-slot:button-area>
      <ItemButton label="戻る" actionType="btn-cancel" @clicked="ncDemandClose()" />
    </template>

  </ItemDialog>
</template>
<script>
import { ref } from "vue";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DialogCancelError",
  setup() {
    const dialogRef = ref(null);

    const openDialog = () => {
      dialogRef.value.open();
    };

    const closeDialog = () => {
      dialogRef.value.close();
    };

    const ncDemandClose = async () => {
      nativeHandlerService.demand.ncDemandClose();
    }

    return {
      dialogRef,
      openDialog,
      closeDialog,
      ncDemandClose,
    };
  },
};
</script>